/**
 * Prints ONE element (the report) on its own.
 *
 * Instead of trying to hide the app's sidebar/navbar with CSS, this copies the report into a
 * hidden, empty page that has the same stylesheets, and prints that page. Nothing else from the
 * app can appear on the paper.
 */
export const printElement = (node, title = "Report") =>
  new Promise((resolve) => {
    if (!node) {
      resolve();
      return;
    }

    const iframe = document.createElement("iframe");
    iframe.setAttribute("aria-hidden", "true");
    iframe.tabIndex = -1;
    Object.assign(iframe.style, {
      position: "fixed",
      right: "0",
      bottom: "0",
      width: "0",
      height: "0",
      border: "0",
    });
    document.body.appendChild(iframe);

    const cleanup = () => {
      setTimeout(() => {
        iframe.remove();
        resolve();
      }, 500);
    };

    const doc = iframe.contentDocument;
    doc.open();
    doc.write(
      '<!doctype html><html><head><meta charset="utf-8"></head><body></body></html>',
    );
    doc.close();
    doc.title = title;

    // Keep the app's theme (for example data-theme="dark") and CSS variables.
    Array.from(document.documentElement.attributes).forEach((a) =>
      doc.documentElement.setAttribute(a.name, a.value),
    );
    doc.body.className = document.body.className;

    // Same styles as the app, so the report looks identical.
    const loading = [];
    document.querySelectorAll('link[rel="stylesheet"], style').forEach((el) => {
      const copy = el.cloneNode(true);
      if (copy.tagName === "LINK")
        loading.push(
          new Promise((r) => {
            copy.onload = r;
            copy.onerror = r;
          }),
        );
      doc.head.appendChild(copy);
    });

    // Charts must fit the paper width.
    const fit = doc.createElement("style");
    fit.textContent =
      ".recharts-wrapper{width:100%!important}.recharts-surface{max-width:100%;height:auto}body{margin:0;background:#fff}";
    doc.head.appendChild(fit);

    doc.body.appendChild(node.cloneNode(true));

    const run = () => {
      try {
        const win = iframe.contentWindow;
        win.focus();
        win.print();
      } finally {
        cleanup();
      }
    };
    // Wait for the stylesheets (max 1.5 s), then print.
    Promise.race([
      Promise.all(loading),
      new Promise((r) => setTimeout(r, 1500)),
    ]).then(() => setTimeout(run, 150));
  });
